import { useLoaderData } from '@remix-run/react';
import logger from '~/services/logger';
import playNextCloseIcon from './assets/play-next-close-icon.png';
import playNextButton from './assets/play-next-button.png';
import { getPayloadImgSrc } from '~/services/layout/layout.ts';
import type { Feed, FeedEntry } from '~/services/layout/index.ts';
import type { loader } from '~/routes/player.tsx';

type Props = {
  feed: Feed;
  totalDuration: number;
  position: number;
  playNext?: (event: any) => void;
  trackData: any;
  isPostroll: boolean;
  showPlayNextOnPostroll: boolean;
  closePlayNextRef: any;
};

export const PlayNext = ({
  playNext,
  feed,
  totalDuration,
  position,
  trackData,
  isPostroll,
  showPlayNextOnPostroll,
  closePlayNextRef,
}: Props) => {
  const { styles } = useLoaderData<typeof loader>();

  try {
    const entry: FeedEntry = feed?.entry?.[0];
    const { title, summary } = entry || {};
    const playNextImage: string | undefined = getPayloadImgSrc(
      { image_key: styles.play_next_image_key },
      entry
    );

    const onClose = () => {
      closePlayNextRef.current = true;
    };

    if (!playNextImage) return <></>;

    if (!showPlayNextOnPostroll && isPostroll) return <></>;

    const upNextCountdownSeconds: number = Math.floor(
      Math.abs(totalDuration - position)
    );

    return (
      <>
        <div className="pointer-events-none absolute bottom-0 right-0 top-0 flex h-full w-full flex-col justify-between">
          <div className="flex flex-row items-center justify-end pb-5 pl-5 pr-5 pt-10 md:pt-5">
            <div className="pr-5 text-xl font-bold text-white">
              {!isPostroll && `Up next in ${upNextCountdownSeconds}`}
            </div>
            <button onClick={onClose} className="pointer-events-auto">
              <img
                src={playNextCloseIcon}
                className="h-5 w-5"
                alt="Play next close icon"
              />
            </button>
          </div>
          <div className="flex w-full justify-end">
            <div className="mb-20 mr-6 w-72">
              <button
                onClick={playNext}
                className="pointer-events-auto relative flex items-center justify-center"
              >
                <img
                  alt="Play next"
                  src={playNextButton}
                  className="absolute h-5 w-5"
                />
                <img
                  alt="Play next preview"
                  src={playNextImage}
                  className="aspect-video w-full rounded-lg"
                />
              </button>
              <div className="justify-start">
                <div className="overflow-hidden text-ellipsis whitespace-nowrap text-white">
                  {title}
                </div>
                <div className="overflow-hidden text-ellipsis whitespace-nowrap text-gray-500">
                  {summary}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } catch (error: any) {
    logger.info(`PlayNext: ${error.message}`);
    return <></>;
  }
};
